/**
 * Mention markup embedded in META_TEXT cell values by the note editor:
 * `@[Display Name](entity-id)`. Capture group 1 is the display label,
 * capture group 2 the referenced entity id.
 *
 * The `g` flag is required by `String.prototype.matchAll`. Both `matchAll` and
 * `replace` operate on an internal clone / reset `lastIndex`, so sharing this
 * single instance between the renderer and the clipboard formatter is safe.
 */
export const META_TEXT_MENTION_PATTERN = /@\[([^\]]+)\]\(([^)]+)\)/g;
